module.exports = __webpack_public_path__ + "img/colored-square.b554c481.svg";